export const overlayOverviewComponentConstants = {
	TRANSPARENT_DIV_ID: 'overlay-overview-transparent',
	FETCHING_OVERLAY_DATA: 'fetching',
	OVERLAY_OVERVIEW_FAILED: 'assets/icons/preview-failed-to-find-overlay-preview.svg'
};

